import _ from "lodash";
import React, { Fragment } from "react";
import {
  Button,
  EmptyState,
  IconButton,
  Modal,
  Tooltip,
} from "@toddle-edu/ds-web";
import classes from "./MemoriesModal.scss";
import { DeleteOutlined } from "@toddle-edu/ds-icons";
import moment from "moment";

import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { getAIMemoriesQuery } from "../../modules/GPTPlaygroundQuery";
import Loading from "UIComponents/Loading";
import { ProjectOverviewIllustration } from "@toddle-edu/ds-theme";
import { deleteAIMemories } from "AppComponents/GPTPlayground/modules/GPTPlaygroundModule";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

const MemoriesModal = props => {
  const {
    onClose,
    memories = [],
    isLoading,
    isData,
    setToastMsg,
    deleteAIMemories,
  } = props;

  const onDeleteMemoryClick = memoryPosition => {
    return async () => {
      const result = await deleteAIMemories({
        input: { bioKeys: [memoryPosition], entityType: props.entityType },
      });
      if (_.get(result, "data.ai.deleteAiMemories.isSuccess", false)) {
        setToastMsg("toastMsgs:deleted_successfully");
      }
    };
  };

  const onClearAllMemoriesClick = async () => {
    if (_.isEmpty(memories)) return;
    const result = await deleteAIMemories({
      input: {
        bioKeys: _.range(1, _.size(memories) + 1),
        entityType: props.entityType,
      },
    });
    if (_.get(result, "data.ai.deleteAiMemories.isSuccess", false)) {
      setToastMsg("toastMsgs:deleted_successfully");
    }
  };

  return (
    <Modal width="650px" height="max-content" onClose={onClose}>
      <Modal.Header
        hasSeparator={true}
        title="Memories of you"
        subtitle="These memories are created through different conversations you have had with the AI."
      />
      <Modal.Body>
        <div className={classes.memoriesListContainer}>
          {isLoading && !isData ? <Loading /> : null}
          {!isData && !isLoading ? (
            <EmptyState
              illustration={ProjectOverviewIllustration}
              title="No memories found"
            />
          ) : null}
          {_.map(memories, (memory, index) => {
            return (
              <Fragment key={"MEMORY_ITEM_" + _.get(memory, "node.id")}>
                <div className={classes.memoryItemContainer}>
                  <Tooltip
                    tooltip={`Created on: ${moment(
                      _.get(memory, "node.createdAt")
                    ).format("lll")}`}
                  >
                    <div className={classes.memoryItem}>
                      {_.get(memory, "node.memory", "untitled")}
                    </div>
                  </Tooltip>
                  <IconButton
                    icon={<DeleteOutlined />}
                    variant="outlined-subtle"
                    size="small"
                    onClick={onDeleteMemoryClick(index + 1)}
                  />
                </div>
                <div className={classes.divider} />
              </Fragment>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: "flex", justifyContent: "flex-start" }}>
        {_.size(memories) > 1 ? (
          <Button
            onClick={onClearAllMemoriesClick}
            variant="inline-destructive"
            size="medium"
          >
            Clear all
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = () => {
  return {
    entityType: "USER",
    isData: true,
    isLoading: false,
  };
};

const mapActionCreators = {
  setToastMsg,
  deleteAIMemories,
};

//export default MemoriesModal;
export default compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getAIMemoriesQuery, {
    name: "getAIMemories",
    options: props => ({
      fetchPolicy: "cache-and-network",
      variables: {
        entityType: props.entityType,
      },
    }),
    props({ getAIMemories, ownProps: { isData, isLoading } }) {
      return {
        memories: _.get(getAIMemories, "ai.aiMemory.edges", []),
        isLoading:
          isLoading ||
          _.includes([1, 2], _.get(getAIMemories, "networkStatus")),
        isData:
          isData && _.get(getAIMemories, "ai.aiMemory.edges", []).length > 0,
      };
    },
  })
)(MemoriesModal);
